import { useOutletContext } from "react-router-dom"
import { Grid } from "@mui/material"

import type { Powerline } from "types/powerlines.types"
import type { Span } from "types/spans.types"

import SpanConductor from "widgets/spans/settings/SpanConductor"
import SpanDetails from "widgets/spans/settings/SpanDetails"
import { BodyContainer } from "widgets/styled/containers"

const SpanSettings = () => {
  const { span, powerline } = useOutletContext<{ span: Span; powerline?: Powerline }>()

  return (
    <BodyContainer disableGutters maxWidth="xl" sx={{ pt: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <SpanDetails span={span} powerline={powerline} />
        </Grid>
        <Grid item xs={12}>
          <SpanConductor span={span} />
        </Grid>
      </Grid>
    </BodyContainer>
  )
}

export default SpanSettings
